import { OrderMailTemplatesSection } from "./sections/mail/OrderMailTemplatesSection";
import { AnfrageSnippetsSection } from "./sections/mail/AnfrageSnippetsSection";
import { MailSignatureSection } from "./sections/mail/MailSignatureSection";
import { useSettingsAcl } from "./lib/useSettingsAcl";
import { useCurrentUser, userIsRealAppAdmin } from "@/lib/auth";

export function KommunikationPage() {
  const acl = useSettingsAcl();
  const { user } = useCurrentUser();
  const isAppAdmin = userIsRealAppAdmin(user);

  if (acl.loading) return null;

  return (
    <div className="space-y-6">
      {acl.canBestellungen && <OrderMailTemplatesSection />}
      {acl.canBestellungen && <AnfrageSnippetsSection />}
      {isAppAdmin ? <MailSignatureSection /> : null}
    </div>
  );
}
